/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Questionnaire_Reporthelper1Inputs */

const en_questionnaire_reporthelper1 = /** @type {(inputs: Questionnaire_Reporthelper1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Contact support by email`)
};

const fr_questionnaire_reporthelper1 = /** @type {(inputs: Questionnaire_Reporthelper1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Contacter le support par courriel`)
};

/**
* | output |
* | --- |
* | "Contact support by email" |
*
* @param {Questionnaire_Reporthelper1Inputs} inputs
* @param {{ locale?: "en" | "fr" }} options
* @returns {LocalizedString}
*/
const questionnaire_reporthelper1 = /** @type {((inputs?: Questionnaire_Reporthelper1Inputs, options?: { locale?: "en" | "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Questionnaire_Reporthelper1Inputs, { locale?: "en" | "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_questionnaire_reporthelper1(inputs)
	return fr_questionnaire_reporthelper1(inputs)
});
export { questionnaire_reporthelper1 as "questionnaire_reportHelper" }